import { action, computed, observable } from "mobx";
import { FormErrors, FormStore } from "@modules/formx";
import locale from "@bonliva-crm/locale";
import { HlrOrderParams } from "@bonliva-crm/shared";
import { OrderCreateData } from "./order-create-data";
import moment from "moment";

export class OrderCreateStore {
  form: FormStore<OrderCreateData>;
  @observable isSubmitting = false;

  constructor(
    initialValues: OrderCreateData | null,
    private itemName: string,
    private onSubmit: ((params: HlrOrderParams) => void) | null,
    private customValidation?: (
      form: FormStore<OrderCreateData>
    ) => FormErrors<OrderCreateData>
  ) {
    this.form = new FormStore<OrderCreateData>({
      initialValues: initialValues || OrderCreateData.Empty(),
      initialDirty: !!initialValues,
      onSubmit: () => Promise.resolve(),
      validate: (formStore) =>
        this.customValidation
          ? this.customValidation(formStore)
          : this.validate(formStore.values)
    });
  }

  @computed get dueDateWithInTenDays() {
    return this.form.values.date
      ? moment(this.form.values.date).diff(moment(), "days") <= 10
      : false;
  }

  validate = (values: OrderCreateData): FormErrors<OrderCreateData> => {
    const errors: FormErrors<OrderCreateData> = {};

    if (!values.place) {
      errors.place = locale.tickets.perfPlaceExt;
    }

    if (!values.date) {
      errors.date = locale.tickets.dueDate;
    }

    if (!values.project) {
      errors.project = locale.tickets.whoChargedProjects;
    }

    if (values.project === "Bonliva" && !values.projectInfo) {
      errors.projectInfo = locale.tickets.whichProjectCharge;
    }

    if (this.dueDateWithInTenDays && !values.dueDateReason) {
      errors.dueDateReason = locale.tickets.dueDateReason;
    }

    return errors;
  };

  @action submit = async (params: { sendEmail: boolean }) => {
    if (!this.form.canSubmit) {
      return;
    }

    const { values } = this.form;

    this.isSubmitting = true;

    try {
      this.onSubmit?.({
        orderType: "hlr",
        type: this.itemName,
        title: values.title,
        place: values.place,
        project: values.project,
        projectInfo: values.projectInfo,
        dueDateReason: values.dueDateReason,
        date: values.date.toISOString(),
        comment: values.comment,
        sendEmail: params.sendEmail
      });
    } finally {
      this.form.reset(OrderCreateData.Empty());
      this.isSubmitting = false;
    }
  };

}
